import { Layout, Row, Col, Space, Typography, Alert, Button } from 'antd';
import {
  AppleOutlined,
  CheckOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import MainHeader from '../MainLayout/MainHeader';
import android from '../../assets/android.svg';
import {
  headerStyle,
  spaceStyle,
  checkboxStyle,
  title,
  headerLayout,
  content,
  subTitle,
  checkOutline,
  alert,
  checkboxText,
  alertIcon,
  alertText,
  layoutRow,
  applicationsSpace,
  applicationsButton,
  androidIcon,
  rightColPadding
} from './styles';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const checkBoxText = [
  'Αναλυτικές οδηγίες εγκατάστασης και σύνδεσης της εφαρμογής',
  'Τα χιλιόμετρα που έχεις διανύσει',
  'Το υπόλοιπο των χιλιομέτρων που σου απομένουν',
  'Την ημερομηνία έναρξης και λήξης των διαδρομών σου'
];
const googlePlay =
  'https://play.google.com/store/apps/details?id=com.shortdrive';
const appStore = 'https://apps.apple.com/us/app/shortdrive-greece/id6444884507';

export default function AuthLayout({ children }) {
  return (
    <Layout style={headerLayout}>
      <Header style={headerStyle}>
        <MainHeader headerMenuRender={false} />
      </Header>
      <Content style={content}>
        <Row
          align="middle"
          justify="center"
          gutter={{ xs: 0, lg: 80 }}
          style={layoutRow}
        >
          <Col xs={24} lg={13} xl={11}>
            <Row align="middle" justify="center">
              <Space
                direction="vertical"
                size={16}
                className="login-left-content"
                style={spaceStyle}
              >
                <Title level={2} style={title}>
                  Καλωσήρθες στο Shortdrive!
                </Title>
                <Text strong style={subTitle}>
                  Μέσω της online εφαρμογής, μπορείς να δεις 24 ώρες το 24ωρο:
                </Text>
                <Space direction="vertical" size={10}>
                  {checkBoxText.map((text, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Space key={i} align="start">
                      <span style={checkboxStyle}>
                        <CheckOutlined style={checkOutline} />
                      </span>
                      <Text strong style={checkboxText}>
                        {text}
                      </Text>
                    </Space>
                  ))}
                </Space>
                <Alert
                  type="info"
                  showIcon
                  icon={<InfoCircleOutlined style={alertIcon} />}
                  message={
                    <Text style={alertText}>
                      Για την ορθή λειτουργία του Ασφαλιστικού προγράμματος
                      Short Drive, είναι απαραίτητο να κατεβάσεις και να
                      συνδεθείς στην εφαρμογή{' '}
                      <Text strong>ShortDrive-Greece</Text>
                    </Text>
                  }
                  className="custom-alert"
                  style={alert}
                />
                <Space direction="vertical" size={0}>
                  <Text>Για τη σύνδεσή σας στην εφαρμογή θα χρειαστείτε:</Text>
                  <Text>
                    Τον <Text strong>αριθμό συμβολαίου σας</Text> και να
                    δημιουργήσετε τον <Text strong>προσωπικό σας κωδικό</Text>{' '}
                    πάνω από 5 χαρακτήρες.
                  </Text>
                </Space>
                <Space direction="vertical" size={12}>
                  <Text type="secondary" style={applicationsSpace}>
                    MOBILE APPLICATIONS
                  </Text>
                  <Space size={12} wrap>
                    <Button
                      icon={<img src={android} alt="" style={androidIcon} />}
                      size="large"
                      style={applicationsButton}
                      onClick={() => window.open(googlePlay, '_blank')}
                    >
                      Google Play
                    </Button>
                    <Button
                      icon={<AppleOutlined />}
                      size="large"
                      style={applicationsButton}
                      onClick={() => window.open(appStore, '_blank')}
                    >
                      App Store
                    </Button>
                  </Space>
                </Space>
              </Space>
            </Row>
          </Col>
          <Col xs={24} lg={11} xl={11} style={rightColPadding}>
            {children}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}
